import { useEffect, useState } from 'react';
import type { AssembledDigest } from '../lambda/alerts/assemble-digest';

export type NewMatchesStatus = 'loading' | 'no-searches' | 'error' | 'ok';

export interface UseNewMatchesResult {
  status: NewMatchesStatus;
  digest: AssembledDigest | null;
}

/** Thin data-fetching shell for GET /api/alerts/new-matches; matches render inline per saved-search card. */
export function useNewMatches(enabled: boolean): UseNewMatchesResult {
  const [status, setStatus] = useState<NewMatchesStatus>('loading');
  const [digest, setDigest] = useState<AssembledDigest | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;

    (async () => {
      try {
        const response = await fetch('/api/alerts/new-matches');
        if (!response.ok) throw new Error(`status ${response.status}`);
        const body = await response.json();
        if (cancelled) return;
        if (!body.hasAlertEnabledSearches) {
          setStatus('no-searches');
        } else {
          setDigest(body.digest);
          setStatus('ok');
        }
      } catch {
        if (!cancelled) setStatus('error');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { status, digest };
}
